import {customEventName} from './constants'

interface EventInfo {
  name: string
  // {@link - https://stackoverflow.com/questions/66603759/accept-any-object-as-argument-in-function}
  data?: Record<string, unknown> | number | string
}

class Analytics {
  private event: CustomEvent<EventInfo>
  private instance: Analytics

  constructor(eventInfo: EventInfo) {
    this.event = new CustomEvent(customEventName, {detail: eventInfo})
    this.instance = this
    this.dispatch = this.dispatch.bind(this)
  }

  dispatch() {
    window.dispatchEvent(this.event)
  }

  asyncDispatch(time = 0) {
    setTimeout(() => {
      this.instance.dispatch()
    }, time)
  }
}

export default Analytics
